<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfBusinesses="true"
              :isRequiredFarms="true"
              :isRequiredBusinesses="true"
              :isRequiredLots="true"
              classFarms="`col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4`"
              classBusinesses="`col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4`"
              classLots="`col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4`"
            >
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12" >
      <div v-if="tableData.length > 0">
        <legend-percentage-inventory /> 
        <card class="custom-shadow-card-header custom-table-responsive"
        >
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-4"
            ></card-header>
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :cellStyle="handleCellStyle"
            >
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <export-tables
            :pdf="{
              filename: `${$t('sowing.inventory_report')}_${dateToday}.pdf`,
              route: 'reports/reportinventory/pdf',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
            :xls="{
              filename: `${$t('sowing.inventory_report')}_${dateToday}.xlsx`,
              route: 'reports/reportinventory/excel',
              paramMethod: 'POST',
              plusData: { ...exportData },
            }"
          />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { getDateToday } from 'src/util/Util';
import configTable from 'src/views/Pages/Dashboard/SowingReports/InventoryReport/inventoryReportTable';
import Legend from 'src/views/Pages/Dashboard/SowingReports/InventoryReport/Legend';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    [Legend.name]: Legend,
  },
  computed: {
    ...configTable().Search,
    exportData() {
      const response = { data: { ...this.tableData } };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    dateToday() {
      return getDateToday();
    },
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  watch: {
    '$i18n.locale': 'setupTable',
  },
  data() {
    return {
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
    };
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.getData();
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.route = 'reports/reportinventory';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';

            this.updateDataPagination(
              'cardfooter',
              [this.from, this.to, this.total],
              5
            );
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    handleCellStyle({ row, columnIndex }) {
      if (Number(columnIndex) == 8) {
        const percentageOfDead = Number(
          row.percentage_of_dead_plants_seeds
        );
        switch (true) {
          case percentageOfDead == 0:
            return 'background-color: #5cf062;';
          case percentageOfDead > 0 && 
            percentageOfDead <= 20:
            return 'background-color: #fed23e;';
          case percentageOfDead >= 20.01 && 
            percentageOfDead <= 100:
            return 'background-color: #ff8484;';
          default:
            break;
        }
      } else if (Number(columnIndex) == 9) {
        const percentageOfReplanted = Number(
          row.percentage_of_replanted_plants_seeds
        );
        const total_plants_seeds_pruning = Number(
          row.total_plants_seeds_pruning
        );
        switch (true) {
          case percentageOfReplanted >= 0 &&
            percentageOfReplanted <= 33.33 &&
            total_plants_seeds_pruning != 0:
            return 'background-color: #ff8484;';
          case percentageOfReplanted >= 33.34 && 
            percentageOfReplanted <= 66.66:
            return 'background-color: #fed23e;';
          case percentageOfReplanted >= 66.67 && 
            percentageOfReplanted <= 100:
            return 'background-color: #5cf062;';
          default:
            break;
        }
      }
    },
  },
  created() {
    this.setupTable();
  },
  mounted() {
    this.selectedItemOnMenu('reports');
  },
  destroyed() {
    this.deselectedItemOnMenu('reports');
  },
};
</script>
